import type { MerchantRole, MerchantUserContext, Permission } from "./types.js";
import { merchantWorkspacePermissionsForRole } from "@price-rescue/domain/permissions";

export function permissionsForRole(role: MerchantRole | undefined): Permission[] {
  return [...merchantWorkspacePermissionsForRole(role)];
}

export function can(user: MerchantUserContext, permission: Permission): boolean {
  return user.status === "ACTIVE" && user.permissions.includes(permission);
}

export function canMutatePricing(user: MerchantUserContext): boolean {
  return can(user, "manage_pricing");
}

export function canManageAccountWithoutBilling(user: MerchantUserContext): boolean {
  return can(user, "manage_account") && !can(user, "manage_billing");
}
